import CardInformation from 'client/common/components/card-information';

export default CardInformation;
